module.exports = __webpack_public_path__ + "static/media/logo.ec8d0a6d.png";